
































































import { Component, Vue } from 'vue-property-decorator';
import getData from './data';

@Component({
  name: 'NewsDetail',
  components: {},
})
export default class extends Vue {
  data: any = {};

  get getQueryParams(): any {
    return this.$route.query;
  }

  created() {
    this.data = getData(this.getQueryParams.id);
  }
}
